module.exports = __webpack_public_path__ + "static/media/gallery-add.ce766823.svg";